import { render, staticRenderFns } from "./ActionMoreProfile.vue?vue&type=template&id=65d93006&"
import script from "./ActionMoreProfile.vue?vue&type=script&lang=js&"
export * from "./ActionMoreProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports